export type ToolSurface = 'public' | 'app';

export interface ToolSurfaceConfig {
  surface: ToolSurface;
  linkBase: string;
  requiresAuth: boolean;
  /**
   * Whether the inline per-tool success state renders on this surface.
   * Public /tools/* pages show it; the signed-in dashboard has its own
   * result chrome and does not.
   */
  successPanel: boolean;
}

const TOOL_SURFACE_CONFIG: Record<ToolSurface, ToolSurfaceConfig> = {
  public: {
    surface: 'public',
    linkBase: '/tools',
    requiresAuth: false,
    successPanel: true,
  },
  app: {
    surface: 'app',
    linkBase: '/tools',
    requiresAuth: true,
    successPanel: false,
  },
};

export function getToolSurfaceConfig(surface: ToolSurface): ToolSurfaceConfig {
  return TOOL_SURFACE_CONFIG[surface];
}

export function getToolIndexHref(config: ToolSurfaceConfig): string {
  return config.linkBase;
}

export function getToolDetailHref(config: ToolSurfaceConfig, slug: string): string {
  return `${config.linkBase.replace(/\/$/, '')}/${slug}`;
}
